export const vaccinationProtocolsTags = {
  PROTOCOLS: 'PROTOCOLS',
};
